<template>
  <form @submit.prevent="submit">
    <fg-input label="Name"
      type="text"
      v-model="costCenter.name"
      :error="valErrors['name'] ? valErrors['name'][0] : null"
    />
    <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
  </form>
</template>

<script>
export default {
  props: ['valErrors', 'initCostCenter', 'submitText'],
  data () {
    return {
      costCenter: this.initCostCenter
    }
  },
  methods: {
    submit () {
      this.$emit('submit', this.costCenter)
    }
  }
}
</script>

<style>
</style>
